export enum TipoSistema {
    APP_MOTORISTA = 1,
    PORTAL_CLIENTE = 2,
    INTEGRACAO = 3,

}
